<template>
  <div
    v-if="!passive || inputValue"
    :class="['checkbox', { error: hasValidationError, disabled }]"
    :style="!passive ? 'max-height: 16px;' : null"
    ref="parent"
  >
    <div
      :class="[
        'checkbox__indicator',
        { checkbox__indicator__active: inputValue, [size]: true },
      ]"
      @click="(e) => !passive && click(e)"
    >
      <svgicon class="indicator__icon" icon="checkmark" v-if="inputValue" />
    </div>
    <input
      type="hidden"
      ref="checkbox"
      v-model="inputValue"
      class="checkbox__value"
      :name="name"
      :disabled="disabled"
    />
    <label
      :class="['checkbox__label', { small: smallText }, { passive }]"
      v-if="label"
      v-html="label"
      @click.self="(e) => !passive && click(e)"
    />
    <slot v-if="hasValidationError" class="validation-messages" />
  </div>
</template>

<script>
import Vue from "vue";
import Base from "@/components/Form/Vinput/Base/Base.vue";

export default Vue.extend({
  name: "checkbox",
  inject: { formData: { from: "formData", default: null } },
  extends: Base,
  validations() {
    return {
      inputValue: this.rules,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    passive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    smallText: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      defaultValue: false,
    };
  },
  computed: {
    rules() {
      const validators = {};

      if (this.required) {
        validators.required = (val) => val == true;
      }

      return validators;
    },
    inputValue: {
      get() {
        if (this.name && this.formData[this.name] !== undefined) {
          return this.formData[this.name];
        } else {
          return this.value;
        }
      },
      set(val) {
        if (this.name && this.formData[this.name] !== undefined) {
          Vue.set(this.formData, this.name, val);
        } else {
          this.$emit("input", val);
        }
      },
    },
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.inputValue = !this.inputValue;
      }
    },
  },
});
</script>

<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  flex-direction: row !important;
  position: relative;
  cursor: pointer;

  &.error {
    .checkbox__indicator {
      border: 1px solid $red;
    }
    .checkbox__label {
      color: $red;
    }
  }

  &.disabled {
    opacity: 0.7;
    cursor: default;

    .checkbox__label {
      cursor: default;
    }
  }

  .checkbox__indicator {
    transition: border 0.2s;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #b8cad5;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: white;

    .indicator__icon {
      position: absolute;
      width: 10px;
      height: 10px;
      fill: white;
    }
  }

  .small {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }

  .large {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;

    .indicator__icon {
      width: 15px;
      height: 15px;
    }
  }

  .checkbox__indicator__active {
    border-color: #0094ff;
    background: #0094ff;
  }

  .checkbox__label {
    margin-left: 8px;
    transition: color 0.2s;
    user-select: none;
    cursor: pointer;
    &.small {
      font-size: 12px;
      color: $gray;
    }
  }
  .checkbox__value {
    display: none;
  }
}
</style>
